import { render, staticRenderFns } from "./dealer-details.vue?vue&type=template&id=7b473e36&scoped=true"
import script from "./dealer-details.vue?vue&type=script&lang=js"
export * from "./dealer-details.vue?vue&type=script&lang=js"
import style0 from "./dealer-details.vue?vue&type=style&index=0&id=7b473e36&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b473e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b473e36')) {
      api.createRecord('7b473e36', component.options)
    } else {
      api.reload('7b473e36', component.options)
    }
    module.hot.accept("./dealer-details.vue?vue&type=template&id=7b473e36&scoped=true", function () {
      api.rerender('7b473e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/participant/dealer/form/dealer-details.vue"
export default component.exports